<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">

          <el-row :span="2" style="margin-top: 30px;">
              Appid:<el-input v-model="name" style="width: 150px;" placeholder="请输入appid"></el-input>
          </el-row>
          
           

          <el-row :span="2" style="margin-top: 30px;">
              <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
          </el-row>
      </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入appid"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="100"
              label="名称"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>
			<el-table-column
			
			  width="800"
			  label="Appid"
			   >
			  <template slot-scope="scope">
			
			    <div>{{scope.row.appid}}</div>
			  </template>
			</el-table-column>
			
			
            
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
		
	
	
	
	
	
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         



      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
		
	
	
	
	
    seach(){
      this.loadList();
    },
    
    
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/base_list'
      })
      .then(res=>{

        this.list = res.data.list;
		this.count = res.data.count;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
              item['lables'] = item['lable'].split(',');
        })
        


      })
      .catch(err=>{

      });
    },

	add(){
	  const axiosInstance = this.$axios.create({
	  	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
	  	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
	  });
	  if(this.name == ''){
	    this.msg('请填写appid','error')
	    return false
	  }
	  
	
	
	  axiosInstance({
	  	method:'post',
	  	url:'http://y31p.yoooooo.com/index.php/index/data/addBase_list',
	  	params:{
	  		name:this.name,
	       
	  		
	
	  	}
	  })
	  .then(res=>{
	
	    this.loadList()
	  })
	  .catch(err=>{
	
	  });
	},


    
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/base.vue